import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    modelValue: _ctx.maintenanceRef,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.maintenanceRef) = $event))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label('maintenance')), 1)
    ]),
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label('maintenanceMessage')), 1)
    ]),
    actions: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_btn, {
        flat: "",
        label: _ctx.label('close')
      }, null, 8, ["label"]), [
        [_directive_close_popup]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}